import React from 'react';
import { BoxArrowUpRight } from 'react-bootstrap-icons';
import AppBackButton from '../common/AppBackButton';
import './InnerPages.css';

const TrendsSource: React.FC = () => {
  return (
    <div className="dashboard-inner-page">
      <AppBackButton />
      <div className="card dashboard-inner-card">
        <div className="card-body">
          <h3 className="card-title">Trend Source</h3>
          <p className="mb-2">April 3 Trend | What Recruiters Are Looking For This Week</p>
          <p className="text-muted mb-3">Source: LinkedIn Talent Blog</p>
          <a
            href="https://www.linkedin.com"
            target="_blank"
            rel="noreferrer noopener"
            className="btn btn-success"
          >
            Open Source <BoxArrowUpRight className="ms-2" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TrendsSource;
